import IconAdjust from '../../../../../components/icons/icon-adjust/icon-adjust';
import { ButtonIcon } from '../../../../../components/inputs/button-icon/button-icon';
import './adjust-credit-button.scss';
interface AddPlanProps {
    onClick: () => void;
}

const AdjustCreditButton: React.FC<AddPlanProps> = ({ onClick }) => {
    return (
        <ButtonIcon Component={IconAdjust} onClick={onClick} />
    );
};

export default AdjustCreditButton;
